const SMALL_WORDS = new Set([
  'a',
  'an',
  'and',
  'as',
  'at',
  'but',
  'by',
  'for',
  'in',
  'is',
  'nor',
  'of',
  'on',
  'or',
  'per',
  'the',
  'to',
  'up',
  'via',
  'vs'
]);

// Prefixes that keep the following hyphen segment lowercase in Title Case
// (e.g. "Co-signer", "Pre-approval"), unlike compounds ("Self-Install").
const HYPHEN_LOWERCASE_PREFIXES = new Set(['anti', 'co', 'e', 'non', 'pre', 're']);

const capitalize = (part: string): string =>
  part.replace(/[a-z]/, letter => letter.toUpperCase());

const capitalizeWord = (word: string): string => {
  const parts = word.split(/([-/])/);
  return parts
    .map((part, index) => {
      // A hyphen segment stays lowercase after a prefix ("Co-signer") or when
      // it is itself a small word ("Trade-in", "Follow-up").
      const followsHyphen = parts[index - 1] === '-';
      const prefix = parts[index - 2]?.toLowerCase() ?? '';
      const keepLowercase =
        followsHyphen &&
        (HYPHEN_LOWERCASE_PREFIXES.has(prefix) || SMALL_WORDS.has(part.toLowerCase()));
      return keepLowercase ? part : capitalize(part);
    })
    .join('');
};

// Words that already contain uppercase (acronyms like VIN/GAP, brands like
// Carvana) are left untouched; only fully-lowercase words are transformed.
const toTitleCase = (text: string): string => {
  const words = text.split(' ');
  return words
    .map((word, index) => {
      if (word !== word.toLowerCase()) {
        return word;
      }
      const isFirstOrLast = index === 0 || index === words.length - 1;
      if (!isFirstOrLast && SMALL_WORDS.has(word)) {
        return word;
      }
      return capitalizeWord(word);
    })
    .join(' ');
};

export default toTitleCase;
